import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=042738a2&scoped=true"
import script from "./TagsSelect.vue?vue&type=script&lang=js"
export * from "./TagsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042738a2",
  null
  
)

export default component.exports